import React, { useCallback, useMemo, useState } from 'react'
import { Button, Card, Pagination, Table } from "antd";
import "./MyProfile.css";
import SuccesIcon from "../../assets/images/Success_button.png.svg"
import FailureIcon from "../../assets/images/Failure_button.png.svg"
import Success from "../../assets/images/Sucess.png.png"
import Failure from "../../assets/images/failure.png.png"

import { formatDate } from "../../util/helper";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { ItemDetailMobile } from "../../components/ItemDetailMobile/myprofile";

const PaymentHistory=({paymentData})=> {
console.log("paymentData",paymentData)
  const { isMobile } = useGetBreakpoints(); 

  const [currentPage, setCurrentPage] = useState(1); 
  const [pageSize, setPageSize] = useState(5); 

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return paymentData.slice(startIndex, endIndex);
  }, [paymentData, currentPage, pageSize]);

  console.log("paginatedData",paginatedData)


  const adjustedPoints = paymentData.transactionamount / 100;

console.log("adjustedPoints",adjustedPoints)

      const columns = [
        {
            title: "TransactionDate",
            key: "transactiondate",
            dataIndex:'transactiondate',
            render: (text) => formatDate(text),
            
          },
        {
          title: "Description",
          key: "description",
          dataIndex:'description',
       
        },
        {
          title: "Currency",
          key: "currency",
          dataIndex:'currency',
        },
        {
          title: "Amount",
          key: "transactionamount",
          dataIndex:'transactionamount',
          align:"right",
          render: (value) => `${Number(value || 0).toLocaleString("en-IN")}`,
        },
        // {
        //   title: "Points",
        //   key: "Points",
        //   dataIndex:'Points',
        //   align:"right",
        // },
        {
            title: "HostPayment ID",
            key: "hostPaymentid",
            dataIndex:'hostPaymentid',
          },
        {
          title: "Status",
          key: "status",
          dataIndex:'status',

          align:"center",
          width: 100,
          render: (text) => (
            <div className={`status ${text === "Success" ? "success" : "failed"}`}>
              <img
                src={
                  text === "Success"
                    ? SuccesIcon 
                    : FailureIcon 
                }
                alt={text}
              />
            </div>
          )
        },
    ]

const StatusComponent = ({ status }) => (
   <div style={{ 
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              marginTop: 10
            }}>
              <div className={`status ${status === 'Success' ? 'success' : 'failed'}`}>
                <img
                  src={status === 'Success' ? SuccesIcon : FailureIcon}
                  alt={status}
                />
              </div>
              </div>
);

  const renderMobileView = useCallback(
  () =>
    paginatedData.map((payment) => (
      <div 
        key={payment.key} 
        style={{ 
          display: 'flex',
          alignItems: 'center',
          padding: '12px 16px',
          gap: '16px',
          borderBottom: '1px solid #f0f0f0',
          background: '#fff',
        }}
      >
        {/* Status Icon */}
        <img
          src={payment.status === 'Success' ? Success : Failure}
          alt="Status"
          style={{ 
            width: '58px',
            height: '58px',
            borderRadius: '8px',
          }}
        />

        {/* Payment Details */}
        <div style={{ flex: 1 }}>
          {/* Primary Row */}
           <div style={{ 
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}>
              {payment.transactiondate}
            </div>
          <div style={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '4px',
          }}>

            <span style={{ 
              fontSize: '15px',
              fontWeight: '500',
              color: '#333',
            }}>
              {payment.description}
            </span>
            <span style={{ 
              fontSize: '15px',
              fontWeight: '600',
              // color: payment.status === 'Success' ? '#28a745' : '#dc3545',
            }}>
              INR {Number(payment.displayAmount || 0).toLocaleString("en-IN")}
            </span>
          </div>

          {/* Secondary Row */}
          <div style={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <span style={{ 
              fontSize: '12px',
              color: '#666',
            }}>
              {payment.hostPaymentid || ' PAYMENT FAIL'} 
            </span>
            <div style={{ 
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontWeight: '600',
            }}>
              {payment.currency}
            </div>
          </div>
          
           <StatusComponent status={payment.status} />
        </div>
      </div>
    )),
  [paginatedData]
);

    const handlePageChange = (page, newPageSize) => {
      console.log('Page changed:', page, 'Page size:', newPageSize);
      setCurrentPage(page);
      if (newPageSize !== pageSize) {
        setPageSize(newPageSize);
        setCurrentPage(1);
      }
    };

    const handleNextPage = () => {
      if (currentPage < Math.ceil(paymentData.length / pageSize)) {
        handlePageChange(currentPage + 1, pageSize);
      }
    };
  
    return (
      <Card>
        <div className="myexim-table-myactivity-title">Payment History</div>
        {isMobile ? (
          
          <>
         
          <div className="mobile-payment-list" >{renderMobileView()}</div>
          
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={paymentData.length}
            onChange={handlePageChange}
            showSizeChanger={false}
            showQuickJumper={false}
            simple
            style={{ marginTop: 16, textAlign: 'center' }}
            
          />
          </>
          
        ) : (
    <Table
      rowKey={"key"}
      className="gx-table-responsive rfq-table myexim-table"
      columns={columns}
      dataSource={paymentData}

      pagination={{
        position: ["bottomRight"],
        pageSize: 5,
      }}
    />
        )}
  </Card>
  )
}

export default PaymentHistory
